type RatingBadgeProps = {
  rating: number;
  size?: "sm" | "md";
};

const RatingBadge = ({ rating, size = "sm" }: RatingBadgeProps) => (
  <span
    className={`inline-flex items-center gap-1 rounded-md bg-accent-500 text-foreground-950 font-semibold ${
      size === "sm" ? "px-1.5 py-0.5 text-[11px]" : "px-2.5 py-1 text-sm"
    }`}
  >
    <i className="ri-star-fill text-[10px]" />
    {rating.toFixed(1)}
  </span>
);

export default RatingBadge;